module.exports = "<!-- Formulario de reporte -->\n<div class=\"card mb-3\">\n    <div class=\"card-body\">\n        <iw-dynamic-form [controls]=\"controls\" [classBtnSubmit]=\"'btn-primary'\" (sended)=\"sendedForm()\"\n        [valueBtnSubmit]=\"'Guardar'\" [disableReset]=\"true\" [hardReset]=\"true\">\n      </iw-dynamic-form>\n    </div>\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/procedure-status-utility/procedure-status-utility.component.html
// module id = ./src/app/shared/procedure-status-utility/procedure-status-utility.component.html
// module chunks = main